module.exports = __webpack_public_path__ + "static/bz-ecbe86bbdbc945d900ce23d24cb0dec0.svg";